"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Icons = exports.CaptionShareIcon = exports.Caption = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('section')(({
  theme
}) => ({
  background: theme.palette.background.paper,
  border: 0,
  borderRadius: 0,
  margin: theme.spacing(3, 0),
  padding: theme.spacing(3, 2),
  [theme.breakpoints.up('sm')]: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3, 5)
  }
}));
const Caption = exports.Caption = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  margin: theme.spacing(1),
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap'
}));
const CaptionShareIcon = exports.CaptionShareIcon = (0, _mui.styled)(_icons.Share)({
  fontSize: '3rem',
  marginRight: '0.5rem'
});
const Icons = exports.Icons = (0, _mui.styled)('div')({
  display: 'block',
  padding: 0
});